import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5468322d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "periodontal-map__header"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "periodontal-map__title" }, "Пародонтальная карта", -1))
const _hoisted_3 = { class: "periodontal-map__header" }
const _hoisted_4 = {
  key: 0,
  class: "periodontal-map__title"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_template = _resolveComponent("icon-template")!
  const _component_e_periodontal_map_table = _resolveComponent("e-periodontal-map-table")!
  const _component_e_periodontal_graphic = _resolveComponent("e-periodontal-graphic")!
  const _component_w_periodontal_report_creation = _resolveComponent("w-periodontal-report-creation")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{ 'periodontal-map--preview': _ctx.isPreviewMode }, "periodontal-map"])
  }, [
    (!_ctx.isPreviewMode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createVNode(_component_icon_template, {
            class: _normalizeClass([{
          'periodontal-map__header-icon__disable':
            _ctx.organizationModules.indexOf('periodontology') <= -1,
        }, "periodontal-map__header-icon"]),
            height: "32",
            name: "open-dialog",
            width: "32",
            onClick: _ctx.handleOpenCreationDialog
          }, null, 8, ["class", "onClick"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_e_periodontal_map_table, {
      columns: _ctx.data?.firstFacialData.getData(),
      class: "periodontal-map__table"
    }, null, 8, ["columns"]),
    _createVNode(_component_e_periodontal_graphic, {
      "facial-side-data": _ctx.data?.firstFacialDiagram,
      "is-upper-teeth": true,
      "tongue-side-data": _ctx.data?.firstTongueDiagram,
      class: "periodontal-map__chart"
    }, null, 8, ["facial-side-data", "tongue-side-data"]),
    _createVNode(_component_e_periodontal_map_table, {
      columns: _ctx.data?.firstTongueData.getData(),
      class: "periodontal-map__table-last",
      "is-reverse": ""
    }, null, 8, ["columns"]),
    _createVNode(_component_e_periodontal_map_table, {
      columns: _ctx.data?.secondFacialData.getData(),
      class: "periodontal-map__table"
    }, null, 8, ["columns"]),
    _createVNode(_component_e_periodontal_graphic, {
      "facial-side-data": _ctx.data?.secondFacialDiagram,
      "is-upper-teeth": false,
      "tongue-side-data": _ctx.data?.secondTongueDiagram,
      class: "periodontal-map__chart",
      "is-reverse": ""
    }, null, 8, ["facial-side-data", "tongue-side-data"]),
    _createVNode(_component_e_periodontal_map_table, {
      columns: _ctx.data?.secondTongueData.getData(),
      "is-reverse": ""
    }, null, 8, ["columns"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.isCreationDialogVisible,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isCreationDialogVisible) = $event)),
      "show-close": false,
      class: "periodontal-map__dialog",
      width: "90%"
    }, {
      header: _withCtx(({ close }) => [
        _createElementVNode("div", _hoisted_3, [
          (!_ctx.isPreviewMode)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, " Пародонтальная карта "))
            : _createCommentVNode("", true),
          _createVNode(_component_icon_template, {
            class: "periodontal-map__header-icon",
            height: "32",
            name: "close-dialog",
            width: "32",
            onClick: close
          }, null, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_w_periodontal_report_creation, {
          visible: _ctx.isCreationDialogVisible,
          onClose: _ctx.handleOpenCreationDialog
        }, null, 8, ["visible", "onClose"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 2))
}